import $ from 'jquery';

function selectPage(pagerElem, panelName) {
    // mark all links as inactive except the one specified
    $(panelName + " .pager-link--active").removeClass('pager-link--active');
    pagerElem.addClass('pager-link--active');

    // detect which page to show
    const index = parseInt(pagerElem.attr('data-from'));

    // hide all lines (items) except the ones on the specified page
    $(panelName + " .panel__items .item").css("display", "none");
    const data = $(panelName + " .panel__items .item");
    for (let i = index; i < (index + 10); i++) {
        $(data[i]).css("display", 'flex');
    }
}

export function initPager(panelName) {
    $(function() {
        selectPage($(panelName + ' .pager-link').first(),panelName);
    });

    $(panelName + " .pager-link").click(e => {
        selectPage($(e.target),panelName);
    });
}